import React from 'react';
import { getRentMonthlyCostItems, sumRentMonthlyCostItems } from '../../utils/submissions';
import RentCostDonutChart, { buildRentDonutSegments } from './RentCostDonutChart';

const RentMonthlyCostsBreakdown = ({ property, country, compact = false }) => {
  const items = getRentMonthlyCostItems(property);
  const base = Number(property?.monthlyRent) || 0;
  const total = base + sumRentMonthlyCostItems(items);
  if (!items.length && base <= 0) return null;
  const segments = buildRentDonutSegments(property);
  const showChart = total > 0 && segments.length > 0;
  return (
    <div className={`rent-monthly-costs-breakdown${compact ? " rent-monthly-costs-breakdown--compact" : ""}`}>
      <h4 style={{ margin: compact ? "0 0 0.65rem" : "0 0 0.75rem", fontSize: compact ? "0.95rem" : "1.05rem" }}>
        {items.length > 0 ? "Monthly costs at a glance" : "Monthly costs breakdown"}
      </h4>
      {showChart && (
        <RentCostDonutChart property={property} total={total} country={country} compact={compact} />
      )}
      <p style={{ fontSize: "0.78rem", color: "var(--text-light)", margin: "0.65rem 0 0", lineHeight: 1.5 }}>
        Amounts are provided by the lister. Confirm final rent and fees with the agent before signing a lease.
      </p>
    </div>
  );
};

export default RentMonthlyCostsBreakdown;
